// ==============================================
// ===================Imports====================
// ==============================================
// ==============================================

import {
  SAVE_LOCATION_MULTIPLE_METADATA,
  SAVED_MULTIPLE_GRID_ROWS,
  SET_DATA_PERCENT,
  SET_ERROR_CODE,
  SET_ERROR_STATUS,
  SET_MODAL_ERR_CO,
  SET_MODAL_NO_DATA,
  SET_MULTIPLE_MARKER,
  SET_MULTIPLE_METADATA_STRING,
  SET_SAVE_FULL_DATA_SELECTED_STATIONS,
  SET_SAVE_MARKER_COMPONENT,
  SET_SAVE_MARKER_SELECTED,
  SET_SAVE_MULTIPLE_LINEAR_OPTION,
  SET_SAVE_MULTIPLE_METADATA_ARRAY,
  SET_SAVE_MULTIPLE_METADATA_ARRAY_LIST_NAME,
  SET_SAVE_MULTIPLE_STATIONS_SELECTED,
  SET_SAVE_STRING_GRID_SELECT,
  SET_TIMESERIES,
} from '../actions/multipleMetadata';

// =================ACTIONS=====================

// ================InitialState==================
const initialState = {
  dataMultiple: {
    markerSelectedArray: [],
    multipleMarker: false,
    markerComponent: [],
    multipleMetadataArray: [],
    multipleMetadataArrayListName: [],
    multipleGridRows: [],
    fullDataSelectedStation: [],
    multipleLinearOptions: {},
    stringGridSelect: '',
    multipleStationsSelected: [],
    modalMultipleMetadataString: '',
    dataPercent: true,
    timeseriesPNG: '',
  },
  modalNoData: false,
  location: '',
  modalErrCo: false,
  errorCode: '',
  statusCode: '',
};

// ==============================================
// ===================Reducer====================
// ==============================================

function multipleMetadataReducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_SAVE_MARKER_SELECTED:
      return {
        ...state,
        dataMultiple: {
          ...state.dataMultiple,
          markerSelectedArray: action.value,
        },
      };
    case SET_MULTIPLE_MARKER:
      return {
        ...state,
        dataMultiple: {
          ...state.dataMultiple,
          multipleMarker: action.value,
        },
      };
    case SET_SAVE_MARKER_COMPONENT:
      return {
        ...state,
        dataMultiple: {
          ...state.dataMultiple,
          markerComponent: action.value,
        },
      };
    case SET_SAVE_MULTIPLE_METADATA_ARRAY:
      return {
        ...state,
        dataMultiple: {
          ...state.dataMultiple,
          multipleMetadataArray: action.value,
        },
      };
    case SAVED_MULTIPLE_GRID_ROWS:
      return {
        ...state,
        dataMultiple: {
          ...state.dataMultiple,
          multipleGridRows: action.value,
        },
      };
    case SET_SAVE_MULTIPLE_METADATA_ARRAY_LIST_NAME:
      return {
        ...state,
        dataMultiple: {
          ...state.dataMultiple,
          multipleMetadataArrayListName: action.value,
        },
      };
    case SET_SAVE_FULL_DATA_SELECTED_STATIONS:
      return {
        ...state,
        dataMultiple: {
          ...state.dataMultiple,
          fullDataSelectedStation: action.value,
        },
      };
    case SET_SAVE_MULTIPLE_LINEAR_OPTION:
      return {
        ...state,
        dataMultiple: {
          ...state.dataMultiple,
          multipleLinearOptions: action.value,
        },
      };
    case SET_SAVE_STRING_GRID_SELECT:
      return {
        ...state,
        dataMultiple: {
          ...state.dataMultiple,
          stringGridSelect: action.value,
        },
      };
    case SET_SAVE_MULTIPLE_STATIONS_SELECTED:
      return {
        ...state,
        dataMultiple: {
          ...state.dataMultiple,
          multipleStationsSelected: action.value,
        },
      };
    case SET_MULTIPLE_METADATA_STRING:
      return {
        ...state,
        dataMultiple: {
          ...state.dataMultiple,
          modalMultipleMetadataString: action.value,
        },
      };
    case SET_MODAL_NO_DATA:
      return {
        ...state,
        modalNoData: action.value,
      };
    case SET_DATA_PERCENT:
      return {
        ...state,
        dataPercent: !action.value,
      };
    case SET_TIMESERIES:
      return {
        ...state,
        dataMultiple: {
          ...state.dataMultiple,
          timeseriesPNG: action.value,
        },
      };
    case SAVE_LOCATION_MULTIPLE_METADATA:
      return {
        ...state,
        location: action.value,
      };
    case SET_MODAL_ERR_CO:
      return {
        ...state,
        modalErrCo: action.value,
      };
    case SET_ERROR_CODE:
      return {
        ...state,
        errorCode: action.value,
      };
    case SET_ERROR_STATUS:
      return {
        ...state,
        statusCode: action.value,
      };
    default:
      return state;
  }
}

export default multipleMetadataReducer;
